/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import LoginLayout from './layout';
import {
  authenticatedAndBrandingReady,
  userIsAuthed,
  platformViewOnlyMode,
  getAvailableTenants,
  getAccountTenants,
  getTenantsList,
  getUsermenuPermission
} from '../../redux/modules/userData/selectors';
import {
  setUserAuthed,
  setUserTenants,
  togglePlatformViewOnlyMode,
  updatePlatformPermissions,
  switchTenant,
  setAccountTenants,
  setTenantsList
} from '../../redux/modules/userData';
import { isInIframe } from 'serenova-js-utils/browser';
import { fetchBranding } from '../../redux/modules/entities/branding/actions';
import { updateUserPermissions } from '../../redux/modules/userData';

import { changeLocale } from '../../redux/modules/language';
import { selectCurrentLocale } from '../../redux/modules/language/selectors';

export function mapStateToProps(state) {
  return {
    hasStarted: authenticatedAndBrandingReady(state),
    authenticated: userIsAuthed(state),
    platformViewOnlyMode: platformViewOnlyMode(state),
    insideIframe: !isInIframe(),
    locale: selectCurrentLocale(state),
    accountTenants: getAccountTenants(state),
    availableTenants: getAvailableTenants(state),
    tenantsList: getTenantsList(state),
    usermenuPermission:getUsermenuPermission(state)
  };
}

export const actions = {
  changeLocale,
  fetchBranding,
  setAccountTenants,
  setTenantsList,
  setUserAuthed,
  setUserTenants,
  switchTenant,
  togglePlatformViewOnlyMode,
  updatePlatformPermissions,
  updateUserPermissions,
};

export default connect(mapStateToProps, actions)(LoginLayout);
